export const initVehicleConfiguration = {
	year: '',
	make: '',
	model: '',
	trimName: '',
	price: '',
	options: {
		drivetrain: {
			value: null,
			keyLabel: 'Drive Type',
			valueLabel: 'TBD',
			modified: false
		},
		paint: {
			value: null,
			keyLabel: 'Paint',
			valueLabel: 'TBD',
			modified: false
		},
		packages: {
			keyLabel: 'Packages',
			valueLabel: 'TBD',
			modified: false,
			selections: []
		}
	}
};

export const initAccountData = {
	accountFranchises: [],
	selectedFranchise: '',
	franchiseModels: {},
	accountTheme: 'white'
};

export const supportedMakes = [
	'acura',
	'alfa-romeo',
	'audi',
	'bmw',
	'buick',
	'cadillac',
	'chevrolet',
	'chrysler',
	'dodge',
	'fiat',
	'ford',
	'genesis',
	'gmc',
	'honda',
	'hyundai',
	'infiniti',
	'jaguar',
	'jeep',
	'kia',
	'land-rover',
	'lexus',
	'lincoln',
	'mazda',
	'mercedes-benz',
	'mini',
	'mitsubishi',
	'nissan',
	'porsche',
	'ram',
	'smart',
	'subaru',
	'toyota',
	'volkswagen',
	'volvo'
];

export const baseExcludedModels = [
	'Chevrolet Express Cutaway',
	'Chevrolet Express Cutaway 4500',
	'GMC Savana Cutaway',
	'GMC Savana Cutaway 4500',
	'Ford E-350 Cutaway',
	'Ford E-450 Cutaway',
	'Ford E-Transit-350 Cab Chassis',
	'Ford E-Transit-350 Cutaway',
	'Ford Transit-250 Cutaway',
	'Ford Transit-250 Cab Chassis',
	'Ford Transit-350 Cab Chassis',
	'Ford Transit-350 Cutaway',
	'Ford F-350 Chassis',
	'Ford F-450 Chassis',
	'Ram ProMaster 3500 Cutaway'
];
